import script from "./ExcelPivotTransformView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcelPivotTransformView.vue?vue&type=script&setup=true&lang=js"

import "./ExcelPivotTransformView.vue?vue&type=style&index=0&id=322da226&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322da226"]])

export default __exports__